import React, { useEffect, useRef } from "react";

interface RichTextIframeProps {
    htmlContent: string;
}

const RichTextIframe: React.FC<RichTextIframeProps> = ({ htmlContent }) => {
    const iframeRef = useRef<HTMLIFrameElement | null>(null);

    useEffect(() => {
        const iframe = iframeRef.current;

        const handleLoad = () => {
            if (
                iframe &&
                iframe.contentDocument &&
                iframe.contentDocument.body
            ) {
                iframe.style.height =
                    iframe.contentDocument.body.scrollHeight + "px";
            }
        };

        if (iframe) {
            iframe.addEventListener("load", handleLoad);
        }

        return () => {
            if (iframe) {
                iframe.removeEventListener("load", handleLoad);
            }
        };
    }, [htmlContent]);

    const wrappedContent = `
    <html>
      <head>
        <style>
          @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;600&display=swap');

          html, body {
            margin: 0;
            padding: 0;
            overflow: hidden;
            font-family: 'Poppins', sans-serif;
            box-sizing: border-box;
          }

          * {
            font-family: 'Poppins', sans-serif !important;
          }
        </style>
      </head>
      <body>
        ${htmlContent}
      </body>
    </html>
  `;

    return (
        <iframe
            ref={iframeRef}
            srcDoc={wrappedContent}
            scrolling="no"
            style={{
                width: "100%",
                border: "none",
                overflow: "hidden",
                height: "100%",
            }}
        />
    );
};

export default RichTextIframe;
